var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { getParts, setAutoValue, setState, getState } from './helpers';
import { updateAutoWidgetProps } from './refresh';
var VALUE_KEY = {
    speedometer: 'speed',
    tachometer: 'rpm',
    fuelGauge: 'fuel',
    engineTemp: 'engineTemp',
    batteryVoltage: 'batteryVoltage',
    cruiseControl: 'cruiseSpeed',
    gearIndicator: 'gear',
    checkEngineLamp: 'checkEngine',
    lowBeamStatus: 'lowBeam',
    parkingLightStatus: 'parkingLight',
    pedestrianDetection: 'pedestrian',
};
function walkParts(node, fn) {
    var e_1, _a;
    fn(node);
    if ('children' in node) {
        try {
            for (var _b = __values(node.children), _c = _b.next(); !_c.done; _c = _b.next()) {
                var child = _c.value;
                walkParts(child, fn);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
}
/** Apply a JSON drive feed to all autoPart nodes in a cluster tree. */
export function applyDriveState(root, state) {
    var _a;
    if ('children' in root && state.incomingCall !== undefined) {
        var prev = getState(root).incomingCall;
        if (prev !== state.incomingCall) {
            updateAutoWidgetProps(root, __assign(__assign(__assign({ incomingCall: state.incomingCall }, (state.caller !== undefined ? { caller: state.caller } : {})), (state.callStatus !== undefined ? { callStatus: state.callStatus } : {})), (state.subtitle !== undefined ? { subtitle: state.subtitle } : {})));
        }
    }
    walkParts(root, function (node) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
        var part = (_a = node.metadata) === null || _a === void 0 ? void 0 : _a.autoPart;
        if (!part)
            return;
        if (part === 'tpms' && state.tpms) {
            setState(node, { pressures: state.tpms });
            (_c = (_b = node.metadata).refresh) === null || _c === void 0 ? void 0 : _c.call(_b, state.tpms);
            return;
        }
        if ((part === 'canViewer' || part === 'canBusSignalMonitor') && state.signals) {
            setState(node, { signals: state.signals });
            (_e = (_d = node.metadata).refresh) === null || _e === void 0 ? void 0 : _e.call(_d, state.signals);
            return;
        }
        if (part === 'turnIndicators' && (state.turnLeft !== undefined || state.turnRight !== undefined)) {
            var left = (_f = state.turnLeft) !== null && _f !== void 0 ? _f : false;
            var right = (_g = state.turnRight) !== null && _g !== void 0 ? _g : false;
            setState(node, { left: left, right: right });
            (_j = (_h = node.metadata).refresh) === null || _j === void 0 ? void 0 : _j.call(_h, left, right);
            return;
        }
        if (part === 'callScreen') {
            if (state.caller !== undefined) {
                (_l = (_k = node.metadata).refresh) === null || _l === void 0 ? void 0 : _l.call(_k, String(state.caller), state.callStatus !== undefined ? String(state.callStatus) : undefined);
            }
            if (state.subtitle !== undefined) {
                setState(node, { subtitle: state.subtitle });
                (_o = (_m = node.metadata).linesRefresh) === null || _o === void 0 ? void 0 : _o.call(_m, [
                    String((_p = state.callStatus) !== null && _p !== void 0 ? _p : 'incoming'),
                    String(state.subtitle),
                ]);
            }
            return;
        }
        var mapped = (_q = VALUE_KEY[part]) !== null && _q !== void 0 ? _q : part;
        var raw = (_r = state[mapped]) !== null && _r !== void 0 ? _r : state[part];
        if (typeof raw === 'number' && typeof node.metadata.refresh === 'function') {
            if (part === 'cruiseControl') {
                setState(node, { speed: raw, active: raw > 0 });
            }
            else {
                setAutoValue(node, 'value', raw);
            }
            node.metadata.refresh(raw);
            return;
        }
        if (typeof raw === 'boolean') {
            setState(node, { active: raw });
            (_t = (_s = node.metadata).boolRefresh) === null || _t === void 0 ? void 0 : _t.call(_s, raw);
            return;
        }
        if (typeof raw === 'string') {
            setState(node, { gear: raw, status: raw, text: raw });
            (_v = (_u = node.metadata).textRefresh) === null || _v === void 0 ? void 0 : _v.call(_u, raw);
            if (part === 'gearIndicator') {
                var label = getParts(node).label;
                if (label)
                    label.text = raw;
            }
        }
    });
    (_a = root.getApp()) === null || _a === void 0 ? void 0 : _a.requestRender();
}
/** Sample drive frames for simulation demos. */
export function sampleDriveFrames(count) {
    if (count === void 0) { count = 60; }
    var frames = [];
    var _loop_1 = function (i) {
        var t = i / count;
        frames.push({
            speed: Math.round(30 + Math.sin(t * Math.PI * 2) * 40 + t * 30),
            rpm: Math.round(1500 + Math.sin(t * Math.PI * 4) * 2000 + t * 1500),
            fuel: Math.max(5, Math.round(80 - t * 40)),
            engineTemp: Math.round(70 + t * 40 + Math.sin(t * 10) * 5),
            batteryVoltage: Math.round((12.2 + Math.sin(t * 5) * 0.3) * 10) / 10,
            stateOfCharge: Math.max(10, Math.round(85 - t * 30)),
            tpms: [32, 31, 33, 32].map(function (p, j) { return (i > 40 && j === 2 ? 22 : p); }),
            parkingBrake: i < 5,
            headlights: i > 10,
            lowBeam: i > 10 && i < 55,
            parkingLight: i > 5 && i < 18,
            checkEngine: i > 85,
            pedestrian: i > 50 && i < 70 ? 'warning' : i > 40 && i < 75 ? 'detecting' : 'clear',
            cruiseSpeed: i > 20 && i < 50 ? 65 : 0,
            gear: i < 5 ? 'P' : 'D',
            turnLeft: i % 30 < 5,
            turnRight: i % 30 > 25,
            incomingCall: i >= 35 && i < 55,
            caller: 'Alex Morgan',
            callStatus: i >= 35 && i < 55 ? 'incoming' : 'ended',
            subtitle: 'Mobile',
            adasStatus: i > 30 ? 'active' : 'standby',
            signals: {
                'engine.rpm': Math.round(1500 + t * 3000),
                'vehicle.speed': Math.round(30 + t * 60),
                'battery.voltage': 12.4,
            },
        });
    };
    for (var i = 0; i < count; i++) {
        _loop_1(i);
    }
    return frames;
}
